<template>
  <v-menu v-model="menu" offset-y left :disabled="readOnly">
    <template v-slot:activator="{ on }">
      <div
        v-on="on"
        class="sentiment-dropdown"
        :class="{
          'sentiment-dropdown--active': active,
          'is-disabled': readOnly
        }"
      >
        <component v-if="active" :is="iconComponent" />

        <v-icon v-if="!readOnly" size="24">
          icon-arrow-down
        </v-icon>

        <v-icon v-if="isBlocked" size="15">
          mdi-lock-outline
        </v-icon>
      </div>
    </template>
    <TagsManagerListSentimentSelectorDropdown
      v-if="menu"
      :sentiment="sentiment"
      @change-sentiment="setSentiment"
      @clear-selection="clearSelection"
    />
  </v-menu>
</template>

<script>
import { SENTIMENT_TYPES } from "@/enums/sentiment";

export default {
  name: "TagsManagerListSentimentSelector",
  components: {
    TagsManagerListSentimentSelectorDropdown: () =>
      import("./TagsManagerListSentimentSelectorDropdown.vue")
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    sentiment: {
      type: [Number, null]
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isBlocked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false,
      currentSentiment: null
    };
  },
  computed: {
    iconComponent() {
      const sentimentIconComponents = {
        [SENTIMENT_TYPES.POSITIVE]: () =>
          import("@/components/ui/Icons/sentiment/PositiveIcon.vue"),
        [SENTIMENT_TYPES.NEGATIVE]: () =>
          import("@/components/ui/Icons/sentiment/NegativeIcon.vue"),
        [SENTIMENT_TYPES.NEUTRAL]: () =>
          import("@/components/ui/Icons/sentiment/NeutralIcon.vue"),
        default: () =>
          import("@/components/ui/Icons/sentiment/UndefinedIcon.vue")
      };
      return (
        sentimentIconComponents[this.currentSentiment] ||
        sentimentIconComponents.default
      );
    }
  },
  methods: {
    setSentiment(sentiment) {
      if (sentiment === this.currentSentiment) return;
      this.$emit("change-sentiment", sentiment);
    },
    clearSelection() {
      // this.currentSentiment = null;
      this.$emit("clear-selection");
    }
  },
  watch: {
    sentiment: {
      handler(current) {
        this.currentSentiment = current;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.sentiment-dropdown {
  padding: $spacing $spacing * 2;
  border-radius: 0 $container-border-radius $container-border-radius 0;
  display: flex;
  align-items: center;
  gap: $spacing;
  height: 100%;

  &--active {
    border-left: 1px solid #a596d5;
    background: $primary;
  }

  &:not(.is-disabled):hover {
    background: rgba(0, 0, 0, 0.1);
  }
}
</style>
